import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  card: {
    height: "calc(12.5 * var(--rhythm))",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      height: "calc(10.5 * var(--rhythm))",
      mb: "var(--rhythm)",
      p: 0,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },

  img: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
});

export default getStyles;
